import {
  initializeSdk,
  InitializeSdkSettings,
} from '@grubhubprod/order-taking-client-sdk/dist/main';
import { getConfig } from 'src/utilities/config';
import { getBrandSettingsFromUrl } from 'src/utilities/sdk';
import { isServerSide } from 'src/utilities/isServerSide';
import { eventBus } from 'src/common/EventBus/eventBus';

const config = getConfig();
const { brand, clientId } = getBrandSettingsFromUrl();

export async function initialize({
  enableGrubApiCore,
  enableCookieAuthentication,
}: Partial<InitializeSdkSettings>): Promise<void> {
  if (!isServerSide()) {
    const sdkConfig: InitializeSdkSettings = {
      jj: config.jjApiUrl,
      client_id: clientId,
      brand,
      storagePrefix: 'ngStorage-',
      enableGrubApiCore,
      enableCookieAuthentication,
      cookieTokenKey: 'ngStorage-oauthTokens',
      eventBus,
    };

    try {
      await initializeSdk(sdkConfig, { hydrate: true });
    } catch (error) {
      console.error('Failed to initialize SDK:', error);
    }
  }
}
